if (!customElements.get('series-tabs')) {
  class SeriesTabs extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('.series-tabs__btn');
      this.panels = this.querySelectorAll('.series-tabs__panel');
      this.customSelect = this.querySelector('custom-select');

      this.buttons.forEach((btn) => {
        btn.addEventListener('click', this.handleTabClick.bind(this));
      });

      if (this.customSelect) {
        this.customSelect.addEventListener('change', this.handleSelectChange.bind(this));
      }

      this.querySelectorAll('.series-tabs__description-toggle').forEach((btn) => {
        const text = btn.previousElementSibling;
        btn.addEventListener('click', () => {
          const expanded = text.classList.toggle('is-expanded');
          btn.setAttribute('aria-expanded', expanded);
          btn.textContent = expanded
            ? (btn.dataset.lessLabel || 'Læs mindre')
            : (btn.dataset.moreLabel || 'Læs mere');
        });
      });

      this.checkToggleVisibility();
    }

    checkToggleVisibility() {
      this.querySelectorAll('.series-tabs__panel').forEach((panel) => {
        const text = panel.querySelector('.series-tabs__description-text');
        const btn = panel.querySelector('.series-tabs__description-toggle');
        if (!text || !btn) return;

        if (panel.classList.contains('is-active')) {
          btn.style.display = text.scrollHeight > text.clientHeight ? 'block' : 'none';
        }
      });
    }

    switchTab(tabId) {
      this.buttons.forEach((b) => b.classList.remove('is-active'));
      this.panels.forEach((p) => p.classList.remove('is-active'));

      const activeBtn = this.querySelector(`[data-tab="${tabId}"]`);
      if (activeBtn) activeBtn.classList.add('is-active');

      if (this.customSelect) {
        const option = this.customSelect.querySelector(`[data-value="${tabId}"]`);
        if (option) this.customSelect.selectOption(option);
      }

      const target = this.querySelector(`[data-panel="${tabId}"]`);
      if (target) target.classList.add('is-active');

      requestAnimationFrame(() => this.checkToggleVisibility());
    }

    handleTabClick(evt) {
      const tabId = evt.currentTarget.getAttribute('data-tab');
      this.switchTab(tabId);
    }

    handleSelectChange(evt) {
      this.switchTab(evt.detail.selectedValue);
    }
  }

  customElements.define('series-tabs', SeriesTabs);
}
